import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { ChatMessageDraftData } from '@shared/models/messenger/messenger.model'

@Injectable({
  providedIn: 'root',
})
export class MessengerDraftService {
  private readonly _state$ = new BehaviorSubject<Record<number, ChatMessageDraftData>>({})
  readonly draftMessages$ = this._state$.asObservable()

  setState(message: Record<number, ChatMessageDraftData>) {
    const state = this._state$.getValue()
    this._state$.next({
      ...state,
      ...message,
    })
  }

  getState() {
    return this._state$.getValue()
  }
}
